import axios from 'axios'

export default class Room {
  static getConnectionData(cid, tourSlug) {
    return axios.post(`/room/slave/${tourSlug}`, { cid: cid }).then(({ data }) => data)
  }
}
